import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'
import { t } from '@/lib/helpers'
import { getPathParams } from '@/lib/routes'
import { useErrorHandler } from '@/lib/hooks'

import { ScriptFormInput } from '../types'
import { COOKIE_CATEGORIES, PROJECT } from '../constants'
import { TOAST_CONFIG } from '@/lib/constants'

type Payload = {
  data: ScriptFormInput
  params: {
    project_id: number
  }
}

const addScript = async ({ data, params }: Payload) => {
  const { project_id } = params

  const response = await fetchAPI<Cookie>({
    path: `/projects/${project_id}/scripts`,
    method: 'post',
    data,
  })

  return response.data
}

export const useAddScript = () => {
  const toast = useToast()
  const handleError = useErrorHandler()
  const queryClient = useQueryClient()

  const { project_id } = getPathParams()
  const params = { project_id: Number(project_id) }

  return useMutation<Cookie, AxiosError, Payload>(addScript, {
    onSuccess() {
      queryClient.invalidateQueries([COOKIE_CATEGORIES, params])
      queryClient.invalidateQueries([PROJECT, params])

      toast({
        ...TOAST_CONFIG,
        title: t('views.features.domains.show.manage.services.script_created'),
      })
    },
    onError(error) {
      handleError(error)
    },
  })
}
